import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { fetchSegments } from '../../actions'

import { editError, editSuccess } from './actions'
import { EDIT_ASYNC } from './constants'

const editEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(EDIT_ASYNC.INITIATE).mergeMap((action) =>
    api.mailboxes
      .updateSegment(store.getState().partnerOptions.selectedCompany?.value, {
        id: action.payload.id,
        name: action.payload.name,
        included_tags: action.payload.includedTags,
        excluded_tags: action.payload.excludedTags,
      })
      .map(({ response }) => {
        if (response.success) {
          store.dispatch(fetchSegments())
        }
        return editSuccess(response || {})
      })
      .catch((error) => Observable.of(epicsErrorHandler(editError, error)))
      .takeUntil(action$.ofType(EDIT_ASYNC.CANCEL))
  )

export default combineEpics(editEpic)
